import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

/**
 * Pencil icon to edit
 *
 * @file Edit.jsx
 * @author Arish Kumar K
 */
const Edit = (props) => (
  // eslint-disable-next-line react/jsx-props-no-spreading
  <SvgIcon viewBox="0 0 24 24" {...props}>
    <path
      fill="currentcolor"
      d="M20.8405891,1.73208983 L22.2710156,3.16389393 C23.2471353,4.14017189
      23.2471353,5.72286342 22.2710156,6.69914137 L5.96952503,23.0038467
      L2,23.0038467 C1.44771525,23.0038467 1,22.5561314 1,22.0038467
      L1,18.0406468 L17.3050552,1.73237628 C18.2812869,0.755986452
      19.8641993,0.755858202 20.8405891,1.73208983 Z M15.5899453,6.27653046
      L3,18.8689584 L3,21.0038467 L5.14098239,21.0038467 L17.7278808,8.41446601
      L15.5899453,6.27653046 Z M19.4265475,3.14647526 C19.2312122,2.95117164
      18.9146297,2.95119729 18.7194082,3.14645041 L18.7194082,3.14645041
      L17.0040194,4.86217747 L19.141955,7.00011302 L20.8566874,5.2850424
      C21.0519114,5.08978681 21.0519114,4.7732485 20.8561213,4.5774265
      L20.8561213,4.5774265 Z"
    />
  </SvgIcon>
);

export default Edit;
